module.exports = __webpack_public_path__ + "img/questions-right-bubble.cbee776b.svg";